export enum FullOrgType {
  SERVICE_USER = 'common:org_types:service_user',
  SUPPLIER = 'common:org_types:supplier',
  OWNER = 'common:org_types:owner',
}
